<template>
	<div>
		<div v-if="showMandatoryError" class="error mb-3">
			{{ mandatoryErrorMessage }}
		</div>
		<div v-if="nothingEligible" class="mb-3">
			<b-form-checkbox v-model="nothing" @input="nothingChanged">
				<span v-html="nothingText" />
			</b-form-checkbox>
		</div>
		<template v-if="!nothing">
			<div
				v-for="region in meta.geoRegion"
				:key="region.id"
				class="mb-3"
			>
				<div>
					<a href="#" class="text-decoration-none" @click.prevent="toggleRegion(region)">
						<Icon icon="caret-up" :rotate="isRegionOpen(region) ? 180 : 90"/>
						<span class="ml-1">
							{{ region.label }}
							<span v-if="getSelectedCount(region)">({{getSelectedCount(region)}})</span>
						</span>
					</a>
				</div>
				<div
					v-if="isRegionOpen(region)"
					class="mt-3 pl-3"
				>
					<div
						v-for="country in region.countries"
						:key="country.id"
						class="mb-1"
					>
						<b-form-checkbox
							:checked="isSelected(country)"
							@change="countryChanged(country, $event)"
						>
							{{ country.text }}
						</b-form-checkbox>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import _ from "lodash";
import Icon from "@/vue/icon/Icon"

export default {

	components: {
		Icon,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		mandatoryErrorMessage: {
			type: String,
			required: false,
		},
		nothingEligible: {
			type: Boolean,
			required: false,
			default: false,
		},
		nothingText: {
			type: String,
			required: false,
		},
		initialNothing: {
			type: Boolean,
			required: false,
			default: false,
		}
	},

	mounted ()
	{
		_.forEach(this.meta.geoRegion, region =>
		{
			const countryIds = _.map(region.countries, 'id');

			const selected = _.filter(
				this.countries,
				country => _.includes(countryIds, country.id)
			);

			if (selected.length > 0)
			{
				this.openRegions.push(region);
			}
		});

		this.emitChangeEvent();
	},

	data ()
	{
		const countryOptions = Object.freeze(
			_.map(this.meta.country, item =>
			{
				return {
					value: item,
					text: item.text,
				}
			}),
		);

		let countries = [];

		if (this.value)
		{
			countries = [];

			_.forEach(this.value, country =>
			{
				const option = _.find(countryOptions, op => op.value.id === country.id);

				if (option)
				{
					countries.push(option.value);
				}
			});
		}

		return {
			countries,
			countryOptions,
			openRegions: [],
			nothing: this.initialNothing,
		};
	},

	computed: {
		showMandatoryError ()
		{
			if (!this.mandatoryErrorMessage)
			{
				return false;
			}

			return !this.nothing && (!this.countries || this.countries.length === 0);
		},
	},

	methods: {
		getSelectedCount (region)
		{
			const selectedCountryIds = (this.countries || []).map(country => country.id);
			const regionCountryIds = _
				.find(this.meta.geoRegion, r => r.id === region.id)
				?.countries
				.map(c => c.id) || [];

			return _.intersection(selectedCountryIds, regionCountryIds).length;
		},
		nothingChanged (checked)
		{
			if (checked)
			{
				this.countries = [];
			}

			this.emitChangeEvent();
		},
		isRegionOpen (region)
		{
			return _.includes(this.openRegions, region);
		},
		toggleRegion (region)
		{
			const regionIds = _.map(this.openRegions, 'id');

			if (_.includes(regionIds, region.id))
			{
				this.openRegions = _.filter(this.openRegions, or => or.id !== region.id);

				return;
			}

			this.openRegions.push(region);
		},
		countryChanged (country, checked)
		{
			this.countries = _.filter(this.countries, c => c.id !== country.id);

			if (checked)
			{
				this.countries.push(country);
			}

			if (this.countries.length > 0)
			{
				this.nothing = false;
			}

			this.emitChangeEvent();
		},
		isSelected (country)
		{
			const ids = _.map(this.countries, 'id');

			return _.includes(ids, country.id);
		},
		emitChangeEvent ()
		{
			if (this.nothingEligible && !this.nothing && this.countries.length === 0)
			{
				this.$emit('input', undefined);
				return;
			}

			if (!this.countries || this.countries.length === 0)
			{
				this.$emit('input', this.nothing ? [] : null);

				return;
			}

			this.$emit('input', this.countries);
		},
	},

	watch: {
		value (v)
		{
			this.countries = v;
		}
	}
}
</script>
